import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftExpertServer } from "namirasoft-expert";
import { NamirasoftInfraServer } from "namirasoft-infra";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { ExpertLayout } from "./ExpertLayout";
import { ExpertRoutes } from "./ExpertRoutes";
import AgentEditPage from "./pages/AgentEditPage";
import AgentListPage from "./pages/AgentListPage";
import AgentSelectPage from "./pages/AgentSelectPage";
import AgentTestPage from "./pages/AgentTestPage";
import AgentViewPage from "./pages/AgentViewPage";
import ChatPage from "./pages/ChatPage";
import LoginPage from "./pages/LoginPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_EXPERT}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_EXPERT = new EnvService("REACT_APP_BASE_URL_EXPERT", true).getString();
            let REACT_APP_BASE_URL_INFRA = new EnvService("REACT_APP_BASE_URL_INFRA", true).getString();

            let expert = new NamirasoftExpertServer(REACT_APP_BASE_URL_EXPERT, result.account.token_manager, result.notifier.onError);
            let infra = new NamirasoftInfraServer(REACT_APP_BASE_URL_INFRA, result.account.token_manager, result.notifier.onError);

            let servers = { expert, infra };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={ExpertRoutes.Home} element={<AgentSelectPage {...result} servers={servers} />} />

                            <Route path={ExpertRoutes.AgentList} element={<AgentListPage {...result} servers={servers} />} />
                            <Route path={ExpertRoutes.AgentNew} element={<AgentEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={ExpertRoutes.AgentView(":id")} element={<AgentViewPage {...result} servers={servers} />} />
                            <Route path={ExpertRoutes.AgentEdit(":id")} element={<AgentEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={ExpertRoutes.AgentCopy(":id")} element={<AgentEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={ExpertRoutes.AgentTest(":id", ":entity_type" as any)} element={<AgentTestPage {...result} servers={servers} />} />
                            <Route path={ExpertRoutes.Chat(":agent_id", ":chat_id", "*")} element={<ChatPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={ExpertRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <ExpertLayout {...props}>
                {props.children}
            </ExpertLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;